import { graphql } from '__generated__';

export const GetStudyPendoMetadataQuery = graphql(`
    query GetStudyPendoMetadata($pk: String!) {
        getStudy(pk: $pk) {
            customerId
            customerName
            sponsorId
            sponsorName
        }
    }
`);
